import { NgModule, InjectionToken } from '@angular/core';
import { CacheService } from './cache.service';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { CacheStorageService } from './cache-storage';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ionic/storage';
export var CONFIG = new InjectionToken('CONFIG');
var cacheConfigDefaults = {
    keyPrefix: ''
};
export function buildCacheService(storage, cacheConfig) {
    cacheConfig = Object.assign(cacheConfigDefaults, cacheConfig);
    return new CacheService(new CacheStorageService(storage, cacheConfig.keyPrefix));
}
var CacheModule = /** @class */ (function () {
    function CacheModule() {
    }
    CacheModule.forRoot = function (cacheConfig) {
        return {
            ngModule: CacheModule,
            providers: [
                { provide: CONFIG, useValue: cacheConfig },
                {
                    provide: CacheService,
                    useFactory: buildCacheService,
                    deps: [Storage, CONFIG]
                }
            ]
        };
    };
CacheModule.ɵfac = function CacheModule_Factory(t) { return new (t || CacheModule)(); };
CacheModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CacheModule });
CacheModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [IonicStorageModule.forRoot({
            name: '__ionicCache',
            driverOrder: ['indexeddb', 'sqlite', 'websql']
        })] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CacheModule, [{
        type: NgModule,
        args: [{
                imports: [
                    IonicStorageModule.forRoot({
                        name: '__ionicCache',
                        driverOrder: ['indexeddb', 'sqlite', 'websql']
                    })
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CacheModule, { imports: [ɵngcc1.IonicStorageModule] }); })();
    return CacheModule;
}());
export { CacheModule };

